// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import md5 from 'js-md5'
import api from './api'
import './utils/utils'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer) 

Vue.config.productionTip = false
Vue.prototype.$api = api;
Vue.prototype.$md5 = md5
Vue.use(ElementUI)
/* eslint-disable no-new */
let that=new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
export default that;


// WEBPACK FOOTER //
// ./src/main.js